<div class="dropdown-menu shadow dropdown-menu-left animated--grow-in dropdown-list show">
  <h6 class="dropdown-header menup">Menu Principal</h6>
  <a class="dropdown-item" href="#" [routerLink]="'/home'" (click)="closeMenu()">
    <i class="fas fa-home fa-sm fa-fw mr-2 text-gray-400"></i>Accueil<br>
  </a>
  <a class="dropdown-item" href="#" [routerLink]="'/dossiers-permanents'" [authorizeRole]="[USER_ROLES.COMPTABILITE,USER_ROLES.ACTIONNAIRE,USER_ROLES.GESTIONNAIRE_EXPENSES]"
     (click)="closeMenu()">
    <i class="far fa-folder-open fa-sm fa-fw mr-2 text-gray-400"></i>Dossiers permanents<br>
  </a>
  <!-- <a class="dropdown-item" href="#" [routerLink]="'/client-requests'" [authorizeRole]="[USER_ROLES.COMPTABILITE]"
     (click)="closeMenu()">
    <i class="far fa-envelope fa-sm fa-fw mr-2 text-gray-400"></i>Intranet sécurisé
  </a> -->
  <a class="dropdown-item" href="#" [routerLink]="'/coopting'"
     [authorizeRole]="[USER_ROLES.COMPTABILITE, USER_ROLES.PORTAGE_SALARIAL,USER_ROLES.ACTIONNAIRE]" (click)="closeMenu()">
    <i class="fas fa-user-friends fa-sm fa-fw mr-2 text-gray-400"></i>Parrainage
  </a>
  <!-- <a  *ngIf="!production || (production && parameters.IsEnaledNewPortageSalarial == false && parameters.IsEnabledOldPortageSalarial == true)"  class="dropdown-item" href="#" (click)="closeMenu()" [authorizeRole]="[USER_ROLES.PORTAGE_SALARIAL]"
     [routerLink]="'/holidays/home'">
    <i class="fas fa-umbrella-beach fa-sm fa-fw mr-2 text-gray-400">
    </i>
    Gestion des congés
  </a> -->
  <a   class="dropdown-item" href="#" (click)="closeMenu()" [authorizeRole]="[USER_ROLES.PORTAGE_SALARIAL]"
  [routerLink]="'/holidays-1/home'">
 <i class="fas fa-umbrella-beach fa-sm fa-fw mr-2 text-gray-400">
 </i>
 Gestion des congés
</a>
<!-- <a   *ngIf="!production || (production && parameters.IsEnaledNewPortageSalarial == false && parameters.IsEnabledOldPortageSalarial == true)"  class="dropdown-item" href="#" (click)="closeMenu()" [routerLink]="'/cra'"
[authorizeRole]="[USER_ROLES.PORTAGE_SALARIAL]">
<i class="far fa-calendar-alt fa-sm fa-fw mr-2 text-gray-400">
</i>
Compte-rendu d'activité
</a> -->
  <a   class="dropdown-item" href="#" (click)="closeMenu()" [routerLink]="'/cra-1'"
     [authorizeRole]="[USER_ROLES.PORTAGE_SALARIAL]">
    <i class="far fa-calendar-alt fa-sm fa-fw mr-2 text-gray-400">
    </i>
    Compte-rendu d'activité
  </a>
  <!-- <a  *ngIf="!production || (production && parameters.IsEnaledNewPortageSalarial == false && parameters.IsEnabledOldPortageSalarial == true)"   class="dropdown-item" href="#" [routerLink]="'/expense-note/home'"
     [authorizeRole]="[USER_ROLES.COMPTABILITE, USER_ROLES.PORTAGE_SALARIAL,USER_ROLES.ACTIONNAIRE]" (click)="closeMenu()">
    <i class="fas fa-sticky-note fa-sm fa-fw mr-2 text-gray-400"></i>Opérations comptables et notes de frais
  </a> -->
  <a    class="dropdown-item" href="#" [routerLink]="'/expense-note-1/home'"
     [authorizeRole]="[USER_ROLES.COMPTABILITE, USER_ROLES.PORTAGE_SALARIAL,USER_ROLES.ACTIONNAIRE, USER_ROLES.GESTIONNAIRE_EXPENSES]" (click)="closeMenu()">
    <i class="fas fa-sticky-note fa-sm fa-fw mr-2 text-gray-400"></i>Opérations comptables et notes de frais
  </a>

  <a class="dropdown-item" href="#" [routerLink]="'/visa-fiscal-ecf'"
     [authorizeRole]="[USER_ROLES.COMPTABILITE]" (click)="closeMenu()">
    <i class="fas fa-gavel fa-sm fa-fw mr-2 text-gray-400"></i>Visa fiscal & Ecf <br>
  </a>
  <!-- <a *ngIf="!production || (production && parameters.IsEnaledNewPortageSalarial == false && parameters.IsEnabledOldPortageSalarial == true)" class="dropdown-item"  [routerLink]="'/simulateur'" [authorizeRole]="[USER_ROLES.COMPTABILITE,USER_ROLES.ACTIONNAIRE]"
     (click)="closeMenu()">
    <i class="fas fa-euro-sign fa-sm fa-fw mr-2 text-gray-400"></i>Simulateurs<br>
  </a> -->
  <a  class="dropdown-item" [routerLink]="'/simulateur-1'" [authorizeRole]="[USER_ROLES.COMPTABILITE,USER_ROLES.ACTIONNAIRE]"
     (click)="closeMenu()">
    <i class="fas fa-euro-sign fa-sm fa-fw mr-2 text-gray-400"></i>Simulateurs<br>
  </a>
  <!-- <a   *ngIf="!production || (production && parameters.IsEnaledNewPortageSalarial == false && parameters.IsEnabledOldPortageSalarial == true)" class="dropdown-item" [routerLink]="'/gestion-document'" [authorizeRole]="[USER_ROLES.COMPTABILITE,USER_ROLES.PORTAGE_SALARIAL]"
     (click)="closeMenu()">
    <i class="fas fa-file-download fa-sm fa-fw mr-2 text-gray-400"></i>Mes documents<br>
  </a> -->
  <a  
   class="dropdown-item" [routerLink]="'/gestion-document-1'" [authorizeRole]="[USER_ROLES.COMPTABILITE,USER_ROLES.PORTAGE_SALARIAL]"
     (click)="closeMenu()">
    <i class="fas fa-file-download fa-sm fa-fw mr-2 text-gray-400"></i>Mes documents<br>
  </a>
  <a class="dropdown-item" href="#" [routerLink]="'/document'" [authorizeRole]="[USER_ROLES.COMPTABILITE, USER_ROLES.ACTIONNAIRE, USER_ROLES.GESTIONNAIRE_EXPENSES]"
     (click)="closeMenu()">
    <i class="fas fa-info-circle fa-sm fa-fw mr-2 text-gray-400"></i>Guides et fiches conseils<br>
  </a>
  <a class="dropdown-item" href="#" (click)="closeMenu()" [routerLink]="'/invoice'" [authorizeRole]="[USER_ROLES.COMPTABILITE]">
    <i class="fas fa-file-invoice fa-sm fa-fw mr-2 text-gray-400"></i>Facturation client
  </a>
  <a *ngIf="showBankModule"  class="dropdown-item" href="#" (click)="closeMenu()" [routerLink]="'/banque'" [authorizeRole]="[USER_ROLES.COMPTABILITE]">
    <i class="fas fa-file-invoice fa-sm fa-fw mr-2 text-gray-400"></i>Banque <!-- <span class="span-new">Nouveau</span> <br> -->
  </a>
  <a class="dropdown-item" href="#" (click)="closeMenu()" [routerLink]="'/compte-resultat'" [authorizeRole]="[USER_ROLES.COMPTABILITE]">
    <i class="fas fa-poll-h fa-sm fa-fw mr-2 text-gray-400"></i>Compte de résultat 
  </a>
  <a class="dropdown-item" href="#" (click)="closeMenu()" [routerLink]="'/electronic-signature'" [authorizeRole]="[USER_ROLES.COMPTABILITE,USER_ROLES.GESTIONNAIRE_EXPENSES]">
    <i class="fas fa-signature fa-sm fa-fw mr-2 text-gray-400"></i>Signature électronique 
  </a>
  <!-- <a class="dropdown-item" href="#" (click)="closeMenu()" [routerLink]="'/sales-register'" [authorizeRole]="[USER_ROLES.COMPTABILITE]">
     <i class="fas fa-chart-line fa-sm fa-fw mr-2 text-gray-400"></i>Suivi des facturations clients <span class="span-new">Nouveau</span><br>
   </a>
    -->
    <a class="dropdown-item" href="#" (click)="closeMenu()" [routerLink]="'/professionnels-IT'">
      <i class="fas fa-poll-h fa-sm fa-fw mr-2 text-gray-400"></i>Découvrir les meilleurs deals pour les professionnels IT <!-- <span class="span-new">Nouveau</span> <br> -->
    </a>
    <!-- <a gIf="!production || (production && parameters.IsEnaledNewPortageSalarial == false && parameters.IsEnabledOldPortageSalarial == true)" class="dropdown-item" href="#" (click)="closeMenu()" [authorizeRole]="[USER_ROLES.PORTAGE_SALARIAL]" [routerLink]="'/portee-tracking'">
      <i class="fas fa-poll-h fa-sm fa-fw mr-2 text-gray-400"></i>Décompte d'activités <!-- <span class="span-new">Nouveau</span> <br> 
    </a> -->
    <a  
    class="dropdown-item" href="#" (click)="closeMenu()" [authorizeRole]="[USER_ROLES.PORTAGE_SALARIAL]" [routerLink]="'/portee-tracking-1'">
      <i class="fas fa-poll-h fa-sm fa-fw mr-2 text-gray-400"></i>Décompte d'activités <!-- <span class="span-new">Nouveau</span> <br> -->
    </a>
      <a  
    class="dropdown-item" href="#" (click)="closeMenu()"  [routerLink]="'/gestionnaires'" [authorizeRole]="[USER_ROLES.COMPTABILITE]" *ngIf="!isExternalLogin">
      <i class="fas fa-poll-h fa-sm fa-fw mr-2 text-gray-400"></i>Inviter un gestionnaire <!-- <span class="span-new">Nouveau</span> <br> -->
    </a>
  <a class="dropdown-item" href="#" (click)="closeMenu()" [routerLink]="'/help'">
    <i class="fas fa-info-circle fa-sm fa-fw mr-2 text-gray-400"></i>Manuel d'utilisation<br>
  </a>

</div>
